import { useState } from "react";
import { JOB_STEPS } from "../CreateJobPage";
import CustomInputV2 from "@components/CustomInputV2/CustomInputV2";
import { ArrowDown, ChevronDown, PlusIcon } from "lucide-react";

const DUMMY_SKILLS = [
  {
    title: "Incident response",
    importance: "Critical",
    requiredLevel: "Advanced",
    experience: "5+ years",
    recency: "Current",
    roleContext: "How this skill will be used",
    isEditing: false,
    howSkillsIsUsed:
      "Applicants should show evidence of coordinating security incidents, working under pressure and turning incident learning into stronger controls.",
  },
  {
    title: "",
    importance: "",
    requiredLevel: "",
    experience: "",
    recency: "",
    roleContext: "",
    isEditing: true,
    howSkillsIsUsed: "",
  },
  //   {
  //     title: "Security governance",
  //     importance: "Critical",
  //     requiredLevel: "Advanced",
  //     experience: "5+ years",
  //     recency: "Current",
  //     roleContext: "How this skill will be used",
  //     isEditing:false,
  //     howSkillsIsUsed:
  //       "Applicants should show evidence of coordinating security incidents, working under pressure and turning incident learning into stronger controls.",
  //   },
  //   {
  //     title: "Stakeholder communication",
  //     importance: "Critical",
  //     requiredLevel: "Advanced",
  //     experience: "5+ years",
  //     recency: "Current",
  //     roleContext: "How this skill will be used",
  //     isEditing:false,
  //     howSkillsIsUsed:
  //       "Applicants should show evidence of coordinating security incidents, working under pressure and turning incident learning into stronger controls.",
  //   },
];

const SkillCard = ({ skill, setSkills, skillIndex }) => {
  const [isSkillUsedExpanded, setIsSkillUsedExpanded] = useState(false);

  const handleRemove = (index) => {
    setSkills((prev) => prev?.filter((_, i) => index !== i));
  };

  //   Create/Edit
  if (skill?.isEditing)
    return (
      <div className="rounded-md border-l-[3px] border-r border-y border-l-slate-600 overflow-hidden">
        <div className="flex justify-between py-3 border-b px-4 bg-slate-100">
          <div className="flex items-center gap-4">
            <span className="text-xss font-bold text-light-black uppercase">
              {String(skillIndex + 1)?.padStart(2, "0")}
            </span>
            <div className="flex flex-col gap-0.5">
              <span className="text-xsss font-bold tracking-wider text-light-black">
                SKILL REQUIREMENT
              </span>
              <CustomInputV2 
                placeholder="e.g. Cloud security"
              />
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="rounded-full px-2 py-1 text-light-black bg-gray-200 text-xsss font-bold">Important</div>
            <button className="border border-light-grey bg-gray-200 rounded-md font-bold text-xsss text-light-black px-3 hover:bg-slate-50 h-8">
              Save Skill
            </button>
            <button
              onClick={() => handleRemove(skillIndex)}
              className="font-bold text-xsss text-light-black hover:bg-slate-50 rounded-md px-3 h-8"
            >
              Remove
            </button>
          </div>
        </div>

        <div className="flex flex-col gap-4 px-4 py-3">
          <div className="grid grid-cols-4 gap-4 items-center">
            <div className="flex flex-col gap-1.5">
              <label className="text-xss font-bold text-light-black">
                Importance
              </label>
              <CustomInputV2 placeholder="" />
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-xss font-bold text-light-black">
                Required level
              </label>
              <CustomInputV2 placeholder="" />
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-xss font-bold text-light-black">
                Minimum experience
              </label>
              <CustomInputV2 placeholder="" />
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-xss font-bold text-light-black">
                Recency
              </label>
              <CustomInputV2 placeholder="" />
            </div>
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-xss font-bold text-light-black">
              How will this skill be used in the role?
            </label>
            <textarea
              className="border rounded-md text-xss font-medium text-light-black p-2"
              placeholder="Describe the decisions, responsibilities or outcomes this skill supports."
              rows={5}
            />
          </div>
        </div>
      </div>
    );

  //   Read only
  return (
    <div className="rounded-md border-l-[3px] border-r border-y border-l-slate-600 overflow-hidden py-3.5 px-4">
      <div className="flex justify-between pb-2.5">
        <div className="flex flex-col">
          <span className="text-xsss font-bold text-light-black uppercase">
            {String(skillIndex + 1)?.padStart(2, "0")} / SKILL REQUIREMENT
          </span>
          <span className="text-md font-semibold text-black">
            {skill?.title}
          </span>
        </div>
        <div className="flex items-center gap-1">
          <button className="border border-slate-600 rounded-md font-bold text-xsss text-slate-600 px-3 hover:bg-slate-50 h-8">
            Edit
          </button>
          <button
            onClick={() => handleRemove(skillIndex)}
            className="font-bold text-xsss text-light-black hover:bg-slate-50 rounded-md px-3 h-8"
          >
            Remove
          </button>
        </div>
      </div>

      <div className="grid grid-cols-[0.9fr_0.9fr_0.9fr_0.9fr_1.4fr] items-center border-y py-2.5">
        <div className="flex flex-col flex-1 gap-0.5">
          <span className="font-bold text-xsss tracking-wider uppercase text-light-black">
            Importance
          </span>
          <span className="text-xss font-bold text-black">
            {skill?.importance}
          </span>
        </div>

        <div className="flex flex-col flex-1 gap-0.5 border-l pl-4">
          <span className="font-bold text-xsss tracking-wider uppercase text-light-black">
            Required Level
          </span>
          <span className="text-xss font-bold text-black">
            {skill?.requiredLevel}
          </span>
        </div>

        <div className="flex flex-col flex-1 gap-0.5 border-l pl-4">
          <span className="font-bold text-xsss tracking-wider uppercase text-light-black">
            Experience
          </span>
          <span className="text-xss font-bold text-black">
            {skill?.experience}
          </span>
        </div>

        <div className="flex flex-col flex-1 gap-0.5 border-l pl-4">
          <span className="font-bold text-xsss tracking-wider uppercase text-light-black">
            Recency
          </span>
          <span className="text-xss font-bold text-black">
            {skill?.recency}
          </span>
        </div>

        <button
          onClick={() => setIsSkillUsedExpanded((prev) => !prev)}
          aria-expanded={isSkillUsedExpanded}
          className={`flex justify-between items-center ml-auto w-max gap-8 px-2 py-1 border rounded-md ${isSkillUsedExpanded ? "bg-slate-100 border-light-grey" : ""} hover:bg-slate-100`}
        >
          <div className="flex flex-col gap-0.5">
            <span className="font-bold text-xsss tracking-wider uppercase text-light-black text-left">
              Role-use Context
            </span>
            <span className="text-xsss font-bold text-black text-left">
              {isSkillUsedExpanded ? "View full text" : "Hide full text"}
            </span>
          </div>

          <div className="flex items-center justify-center w-6 h-6 rounded-full border bg-white shrink-0">
            <ArrowDown
              size={12}
              className={`transition-transform duration-200 ease-out ${
                isSkillUsedExpanded ? "rotate-180" : "rotate-0"
              }`}
            />
          </div>
        </button>
      </div>

      {isSkillUsedExpanded ? (
        <div className="flex flex-col gap-1 p-4 mt-3 border-l-[3px] border-y border-r border-gray-200 rounded-r-md border-l-slate-600 bg-slate-50">
          <span className="font-bold text-xsss text-light-black tracking-wider uppercase">
            How this skill is used in the role
          </span>
          <span className="text-xss font-medium text-charcoal leading-4">
            {skill?.howSkillsIsUsed}
          </span>
        </div>
      ) : null}
    </div>
  );
};

const Step4 = ({ activeStep }) => {
  const [skills, setSkills] = useState(DUMMY_SKILLS);

  return (
    <>
      {/* Header */}
      <div className="flex border-b pb-3">
        <div className="flex flex-col gap-0.5 flex-1">
          <span className="text-xss font-bold text-light-black uppercase">
            Step {String(activeStep).padStart(2, "0")} /{" "}
            {JOB_STEPS[activeStep - 1]?.label}
          </span>
          <span className="font-semibold text-xl">
            {JOB_STEPS[activeStep - 1]?.title}
          </span>
          <span className="text-xss font-medium text-light-black">
            {JOB_STEPS[activeStep - 1]?.subtitle}
          </span>
        </div>
        <span className="self-end text-xss font-bold text-light-black uppercase leading-3">
          {JOB_STEPS[activeStep - 1]?.tagline}
        </span>
      </div>

      <div className="flex flex-col mt-5 gap-3">
        {skills?.map((skill, skillIndex) => {
          return (
            <SkillCard
              skillIndex={skillIndex}
              skill={skill}
              setSkills={setSkills}
            />
          );
        })}
        <button
          onClick={() =>
            setSkills((prev) => [
              ...prev,
              {
                title: "",
                importance: "",
                requiredLevel: "",
                experience: "",
                recency: "",
                roleContext: "",
                isEditing: true,
                howSkillsIsUsed: "",
              },
            ])
          }
          className="flex items-center rounded-md border border-dashed bg-slate-50 font-bold text-slate-600 text-xss h-10 w-max px-3 gap-2 hover:bg-white"
        >
          <PlusIcon size={14} />
          Add another skill requirement
        </button>
      </div>
    </>
  );
};

export default Step4;
